import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Planset-service Component
 */
export class PlansetService {

  firbasebasecollname: string = 'vendors';
  currentuser!: CurrentUser;
  firebaseclientcollname: string = 'clients';

  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    this.currentuser = this.tokenService.getCurrentUser();
  }

  /**
   * ADD PLANSET RECORD API
   */
  addPlansetsData(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + GlobalComponent.plansetsGet, postdata);
  }

  /**
   * GET PLANSET RECORD API
   * fetch record on basis of record guid
   */
  getPlansetsRecordData(recordguid: string) : Observable<any> {
    console.log("fetching planset data");
    return this.http.get<any>(BASE_URL + 'planset/details/' + recordguid);
  }

  /**
   * UPDATE PLANSET STATUS
   */
  updatePlansetStatus(recordguid: string, postdata: any) : Observable<any>{
    return this.http.put<any>(BASE_URL + 'planset/update/' + recordguid,  {data: postdata});
  }

  /**
   * GET PLANSET MEMBERS LIST
   */
  getPlansetsMembersList(recordguid: string) : Observable<any[]> {
    console.log("fetching planset members list");
    return this.http.get<any[]>(BASE_URL + 'planset/memberlist/' + recordguid);
  }

  /**
   * CANCEL PLANSET PROJECT
   */
  cancelPlansetProject(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + 'plansetcancels', {data: postdata});
  }

  /**
   * GET PLANSET ATTACHMENTS
   */
  getPlansetsAttachments(recordguid: string) : Observable<any[]> {
    console.log("fetching planset attachments list");
    return this.http.get<any[]>(BASE_URL + 'plansetattachments/attachments/'+recordguid);
  }

   /**
   * UPDATE PLANSET RECORD API
   */
   editPlansetsData(postdata: any, recordId: number) : Observable<any>{
    return this.http.put<any>(BASE_URL + GlobalComponent.plansetsGet + '/' + recordId, postdata);
  }

  /**
   * RELEASE RECORD
   */
  releaserecord(jobguid: string, postdata: any) {
    return this.http.put<any>(BASE_URL + 'planset/releaserecord/' + jobguid, {data: postdata});
  }

   /**
   * GET PLANSET FILE ATTACHMENT TO DOWNLOAD FILE
   */
  getPlansetFile(recordguid: string) : Observable<any[]> {
    return this.http.get<any[]>(BASE_URL + 'plansetattachments?filters[activestate][$eq]=true&filters[fieldname][$eq]=plansetfile&filters[jobguid][$eq]='+recordguid+'&populate=*');
  }

  /**
   * DELETE LATEST REVISION
   */
  deleterevision(id: number) {
    return this.http.put<any>(BASE_URL + 'plansetrevisionjobs/' + id, { data: { activestate: false }});
  }

  /**
   * GET PLANSET RECORD API VIA ADDRESS
   * fetch record on basis of record guid
   */
  getPlansetsRecordDataViaAddress(address: string, clientguid: string) : Observable<any> {
    console.log("fetching planset data via address");
    let c_guid = '';
    if (clientguid == null && clientguid == undefined) {
      c_guid = '';
      console.log("c_guid", c_guid);
    }else{
      c_guid = `&filters[clientguid][$eq]=${clientguid}`;
      console.log("c_guid", c_guid);
    }
    console.log(BASE_URL + 'plansets?filters[address][$eq]=' + address + "&filters[activestate][$eq]=true" + c_guid);
    return this.http.get<any>(BASE_URL + 'plansets?filters[address][$eq]=' + address + "&filters[activestate][$eq]=true"+c_guid);
  }

  /**
  * STRUCTURAL INFORMATION DATA
  */
  addStructuralInformation(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + 'plansetroofdetail/add', { data: postdata });
  }

  /**
  * UPDATE STRUCTURAL INFORMATION
  */
  updateStructuralInformation(id: number, postdata: any) : Observable<any>{
    return this.http.put<any>(BASE_URL + 'plansetroofdetails/' + id, { data: postdata });
  }

  /**
  * UPDATE PLANSET ATTACHMENT RECORD
  */
  updatePlansetsAttachment(attachmentId: number, postdata: any) : Observable<any> {
    return this.http.put<any>(BASE_URL + 'plansetattachments/' + attachmentId, {data: postdata});
  }

}